
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

// Type for a single banner ad
export type BannerAd = {
  id: string;
  image_url: string;
  alt_text: string | null;
  target_url: string | null;
  enabled: boolean;
};

export function useBannerAds(): {
  banners: BannerAd[];
  loading: boolean;
  error: string | null;
} {
  const [banners, setBanners] = useState<BannerAd[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchBanners() {
      setLoading(true);
      setError(null);
      const { data, error } = await supabase
        .from("banner_ads")
        .select("*")
        .eq("enabled", true)
        .order("created_at", { ascending: false });

      if (!cancelled) {
        if (error) {
          setError("Failed to load banner ads.");
        } else if (data) {
          setBanners(data);
        }
        setLoading(false);
      }
    }

    fetchBanners();

    return () => {
      cancelled = true;
    };
  }, []);

  return { banners, loading, error };
}
